/** Format a numeric value as Baht with commas and 2 decimal places */
export const fmtBaht = (v: number | string): string =>
  `฿${Number(v || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Format a numeric value with commas and 2 decimal places (no ฿ prefix) */
export const fmtMoney = (v: number | string): string =>
  Number(v || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Format a numeric value with commas (no decimals) */
export const fmtNum = (v: number | string): string =>
  Number(v || 0).toLocaleString();
